// ============================================
// FILE: src/components/PrivacyPolicyScreen.jsx
// ============================================

import { ArrowLeft } from 'lucide-react';

const PrivacyPolicyScreen = ({ onBack = null, setActiveTab, appTheme = 'blue' }) => {
  const goHome = () => setActiveTab && setActiveTab('home');

  // Header style
  const headerStyle = appTheme === 'white'
    ? { background: '#fff', color: '#222', boxShadow: '0 2px 16px 0 rgba(0,0,0,0.04)' }
    : { background: 'var(--primary-gradient)', color: 'var(--text-light)' };

  return (
    <div className="pb-20 min-h-screen" style={{ background: 'var(--primary-bg)', color: 'var(--text-main)' }}>
      {/* ─── HEADER ─── */}
      <div className="p-6 rounded-b-3xl shadow-lg" style={headerStyle}>
        <div className="flex items-center gap-3 mb-4">
          <button
            onClick={onBack || goHome}
            className="p-2 hover:bg-white hover:bg-opacity-20 rounded-lg transition-all"
          >
            <ArrowLeft size={22} />
          </button>
          <h2 className="text-lg font-semibold">Privacy Policy</h2>
        </div>
      </div>
      {/* ─── CONTENT ─── */}
      <div className="p-4 space-y-4">
        <div className="bg-white rounded-xl shadow-sm p-4">
          <h3 className="font-semibold text-gray-800 mb-3">1. Information Collection</h3>
          <p className="text-gray-600 text-sm leading-relaxed">
            We collect personal information you provide, such as your name, contact details, and address, to deliver our services.
          </p>
        </div>
        <div className="bg-white rounded-xl shadow-sm p-4">
          <h3 className="font-semibold text-gray-800 mb-3">2. Use of Information</h3>
          <p className="text-gray-600 text-sm leading-relaxed">
            Your information is used to process orders, improve our services, and communicate with you about your account or offers.
          </p>
        </div>
        <div className="bg-white rounded-xl shadow-sm p-4">
          <h3 className="font-semibold text-gray-800 mb-3">3. Data Security</h3>
          <p className="text-gray-600 text-sm leading-relaxed">
            We implement security measures to protect your data. However, no method of transmission over the internet is 100% secure.
          </p>
        </div>
        <div className="bg-white rounded-xl shadow-sm p-4">
          <h3 className="font-semibold text-gray-800 mb-3">4. Sharing of Information</h3>
          <p className="text-gray-600 text-sm leading-relaxed">
            We do not sell or rent your personal information. We may share it with trusted partners to fulfill your orders or comply with the law.
          </p>
        </div>
        <div className="bg-white rounded-xl shadow-sm p-4">
          <h3 className="font-semibold text-gray-800 mb-3">5. Cookies</h3>
          <p className="text-gray-600 text-sm leading-relaxed">
            Our app may use cookies to enhance your experience. You can disable cookies in your browser settings if you prefer.
          </p>
        </div>
        <div className="bg-white rounded-xl shadow-sm p-4">
          <h3 className="font-semibold text-gray-800 mb-3">6. Changes to Policy</h3>
          <p className="text-gray-600 text-sm leading-relaxed">
            We may update this privacy policy from time to time. Please review it periodically for changes.
          </p>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicyScreen;
